import { render, staticRenderFns } from "./multiselect-tags.vue?vue&type=template&id=773625b6&"
import script from "./multiselect-tags.component.ts?vue&type=script&lang=ts&"
export * from "./multiselect-tags.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports